/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speaker_Manager_Edit_TitleInputs */

const en_speaker_manager_edit_title = /** @type {(inputs: Speaker_Manager_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit Speaker`)
};

const fr_speaker_manager_edit_title = /** @type {(inputs: Speaker_Manager_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifier le locuteur`)
};

const de_speaker_manager_edit_title = /** @type {(inputs: Speaker_Manager_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprecher bearbeiten`)
};

const it_speaker_manager_edit_title = /** @type {(inputs: Speaker_Manager_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifica relatore`)
};

const ru_speaker_manager_edit_title = /** @type {(inputs: Speaker_Manager_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Редактировать спикера`)
};

const es_speaker_manager_edit_title = /** @type {(inputs: Speaker_Manager_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar orador`)
};

const zh_cn2_speaker_manager_edit_title = /** @type {(inputs: Speaker_Manager_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编辑发言人`)
};

const ja_speaker_manager_edit_title = /** @type {(inputs: Speaker_Manager_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スピーカーを編集`)
};

const hi_speaker_manager_edit_title = /** @type {(inputs: Speaker_Manager_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्पीकर संपादित करें`)
};

const pt_pt2_speaker_manager_edit_title = /** @type {(inputs: Speaker_Manager_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar alto-falante`)
};

/**
* | output |
* | --- |
* | "Edit Speaker" |
*
* @param {Speaker_Manager_Edit_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speaker_manager_edit_title = /** @type {((inputs?: Speaker_Manager_Edit_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speaker_Manager_Edit_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speaker_manager_edit_title(inputs)
	if (locale === "de") return de_speaker_manager_edit_title(inputs)
	if (locale === "it") return it_speaker_manager_edit_title(inputs)
	if (locale === "ru") return ru_speaker_manager_edit_title(inputs)
	if (locale === "es") return es_speaker_manager_edit_title(inputs)
	if (locale === "zh-CN") return zh_cn2_speaker_manager_edit_title(inputs)
	if (locale === "ja") return ja_speaker_manager_edit_title(inputs)
	if (locale === "hi") return hi_speaker_manager_edit_title(inputs)
	if (locale === "pt-PT") return pt_pt2_speaker_manager_edit_title(inputs)
	return en_speaker_manager_edit_title(inputs)
});